package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlin.time.Instant

@Serializable
data class GmInventoryItem(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("name")
    val name: String,

    @SerialName("category")
    val category: ItemCategory,

    @SerialName("quantity")
    val quantity: Int,

    @SerialName("image_url")
    val imageUrl: String? = null,

    @Transient
    val signedImageUrl: String? = null,

    @SerialName("created_at")
    val createdAt: Instant,

    @SerialName("updated_at")
    val updatedAt: Instant
)
